const definitionFeed = (definition, currentSearch) => {
    let highlighting = false;
    if (currentSearch.trim() !== '' &&
        definition.title.toLowerCase().startsWith(currentSearch.trim())
    ) {
        highlighting = `<mark class="highlight">${definition.title.slice(0, currentSearch.length)}</mark>${definition.title.slice(currentSearch.length)}`;
    }
    return `<article class="feed-definition" id="feed-definition-${definition.ID}">
    <div class="feed-definition__wrapper">
        <span class="wrapper__title">${highlighting ? highlighting : definition.title}</span>
        <p class="wrapper__content">${definition.description}</p>
    </div>
</article>`;
}

const letterDefinitionFeed = (definition) => {
    return `<article class="feed-definition-letter" id="feed-definition-letter-${definition.toLowerCase()}">
    <div class="feed-definition-letter__wrapper">
        <span class="wrapper__title">${definition}</span>
    </div>
</article>`;
}

export {definitionFeed, letterDefinitionFeed};
